"use strict";

var _interopRequireDefault = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _MultiLanguageInp = _interopRequireDefault(require("@/components/MultiLanguageInp"));
var _aftersale = require("@/api/aftersale");
var _multiLanguageDisplay = require("@/utils/multiLanguageDisplay");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ConfigLevel',
  components: {
    Pagination: _Pagination.default,
    MultiLanguageInp: _MultiLanguageInp.default
  },
  data: function data() {
    return {
      multiLanguageDisplay: _multiLanguageDisplay.multiLanguageDisplay,
      list: [],
      total: 0,
      listLoading: true,
      listQuery: {
        pageNo: 1,
        pageSize: 20,
        reason: undefined,
        type: undefined
      },
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑原因',
        create: '新增原因'
      },
      dataForm: {
        id: '',
        reason: '',
        responder: '',
        type: ''
      },
      listConfig: [{
        label: "取消订单-国内",
        value: 1
      }, {
        label: "仅退款-国内",
        value: 2
      }, {
        label: "退货退款-国内",
        value: 3
      }, {
        label: "取消订单-海外",
        value: 4
      }, {
        label: "仅退款-海外",
        value: 5
      }, {
        label: "定金退款-国内",
        value: 6
      }, {
        label: "定金退款-国外",
        value: 7
      }],
      listresponder: ['买家', '卖家', '平台'],
      required: {
        required: true,
        message: '请填写售后原因',
        trigger: 'blur'
      },
      rules: {
        reason: [{
          required: true,
          message: '请填写售后原因',
          trigger: 'blur'
        }],
        responder: [{
          required: true,
          message: '请选择责任归属',
          trigger: 'change'
        }],
        type: [{
          required: true,
          message: '请选择售后类别',
          trigger: 'change'
        }]
      },
      btnLoading: false
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    handleFilter: function handleFilter() {
      this.listQuery.pageNo = 1;
      this.getList();
    },
    reset: function reset() {
      this.listQuery = {
        pageNo: 1,
        pageSize: 20,
        reason: undefined,
        type: undefined
      };
      this.getList();
    },
    // 获取列表
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      (0, _aftersale.reasonList)((0, _objectSpread2.default)({}, this.listQuery)).then(function (response) {
        _this.list = response.data.data.list;
        _this.total = response.data.data.total;
        _this.listLoading = false;
      }).catch(function () {
        _this.list = [];
        _this.listLoading = false;
      });
    },
    // 新增
    handleCreate: function handleCreate() {
      var _this2 = this;
      this.resetForm();
      this.dialogStatus = 'create';
      this.dialogFormVisible = true;
      this.$nextTick(function () {
        _this2.$refs['dataForm'].clearValidate();
      });
    },
    // 重置表单
    resetForm: function resetForm() {
      this.dataForm = {
        id: '',
        reason: '',
        responder: '',
        type: ''
      };
    },
    handleDelete: function handleDelete(row) {
      var _this3 = this;
      this.$confirm('是否要进行删除操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _aftersale.reasonDelete)({
          id: row.id
        }).then(function (response) {
          if (response.data.errno == 0) {
            _this3.getList();
            _this3.$message.success('删除成功');
          }
        });
      }).catch(function () {});
    },
    format: function format(status) {
      switch (status) {
        case 1:
          return '取消订单-国内';
        case 2:
          return '仅退款-国内';
        case 3:
          return '退货退款-国内';
        case 4:
          return '取消订单-海外';
        case 5:
          return '仅退款-海外';
        case 6:
          return '定金退款-国内';
        case 7:
          return '定金退款-国外';
        default:
          return "-";
      }
    },
    handleData: function handleData() {
      var _this4 = this;
      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          _this4.btnLoading = true;
          (0, _aftersale.reasonEdit)((0, _objectSpread2.default)({}, _this4.dataForm)).then(function (response) {
            _this4.btnLoading = false;
            if (response.data.errno == 0) {
              _this4.getList();
              _this4.dialogFormVisible = false;
              _this4.$message.success('提交成功');
            }
          }).catch(function () {
            _this4.btnLoading = false;
          });
        }
      });
    },
    // 修改
    handleUpdate: function handleUpdate(row) {
      var _this5 = this;
      this.dataForm = Object.assign({}, row);
      this.dialogStatus = 'update';
      this.dialogFormVisible = true;
      this.$nextTick(function () {
        _this5.$refs['dataForm'].clearValidate();
      });
    }
  }
};